import user from "./user";
import measures from "./measures";
import sizeRecommendation from "./sizeRecommendation";
import sizeAdvisor from "./sizeAdvisor";
import friends from "./friends";

export default {
  ...user,
  ...measures,
  ...sizeRecommendation,
  ...sizeAdvisor,
  ...friends
};
